export enum $workspaceFindingCount {
  _id = '_id',
  workspaceId = 'workspaceId',
  toolName = 'toolName',
  computedDate = 'computedDate',
  remediationProgress = 'remediationProgress',
  mostCompromisedDigitalProperties = 'mostCompromisedDigitalProperties',
  previousData = 'previousData',
  mostViolatedSuccessCriteria = 'mostViolatedSuccessCriteria',
  mostViolatedSuccessCriteriaByStandard = 'mostViolatedSuccessCriteriaByStandard',
  countByActiveDigitalProperty = 'countByActiveDigitalProperty',
  agingUnresolvedIssues = 'agingUnresolvedIssues',
  a11yPolicyThresholds = 'a11yPolicyThresholds',
  tenantId = 'tenantId',
}
